import type { Environment } from "./types";

// Injected at build time by esbuild.mjs from .env.<environment> — see .env.example.
declare const __API_BASE_URL__: string;
// Injected at build time by esbuild.mjs from package.json's "version" field.
declare const __APP_VERSION__: string;
// Injected at build time by esbuild.mjs, generated from git tags/log: a JSON-encoded
// array of { version, items } from newest to oldest release.
declare const __APP_CHANGELOG__: string;

export const API_BASE_URL = __API_BASE_URL__;
export const APP_VERSION = __APP_VERSION__;
export const APP_CHANGELOG: { version: string; items: string[] }[] = JSON.parse(__APP_CHANGELOG__);

export const ENVIRONMENTS: Environment[] = ["DEV", "TEST", "PROD"];

export function webClientUrl(environment: Environment, solution: string): string {
  if (environment === "PROD") {
    return `https://web.parsonii.cloud/PROD/${solution}`;
  }
  return `https://web.${environment.toLowerCase()}.parsonii.cloud/${solution}`;
}
